import React from 'react'
import { Card } from 'react-bootstrap'

export default function CardAjuda() {
  return (
    <Card>
    <Card.Body className='text-center'>
      <i className='fas fa-question-circle f-40'></i>
      <h6 className='mt-3'>Precisa de ajuda?</h6>
      <p>Não fique com dúvidas! Acesse nossa Central de Ajuda.</p>
      <a
        id='btnAjudaIni'
        href='https://ajuda.espiaonfe.com.br'
        target='_blank'
        className='btn btn-primary btn-sm text-white m-0 text-decoration-none'
        rel='noreferrer'
      >
        Ajuda
      </a>
    </Card.Body>
  </Card>
  )
};
